import { render, staticRenderFns } from "./CouponIndex.vue?vue&type=template&id=524af192&scoped=true&"
import script from "./CouponIndex.vue?vue&type=script&lang=js&"
export * from "./CouponIndex.vue?vue&type=script&lang=js&"
import style0 from "./CouponIndex.vue?vue&type=style&index=0&id=524af192&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524af192",
  null
  
)

component.options.__file = "CouponIndex.vue"
export default component.exports